module.exports = __webpack_public_path__ + "img/T34.99719d54.jpg";